import { Box, Typography } from "@mui/material";
import { formatWeekdayTime } from "./functions";
import { sharedStyles } from "@/styles/shared";
import { useTranslation } from "react-i18next";

interface TimeRangeInterpreterProps {
  timeMonday: string[];
  timeTuesday: string[];
  timeWednesday: string[];
  timeThursday: string[];
  timeFriday: string[];
  timeSaturday: string[];
  timeSunday: string[];
}

const TimeRangeInterpreter = (props: TimeRangeInterpreterProps) => {
  const { t } = useTranslation();

  const days = [
    t("translation:timeRange.days.monday"),
    t("translation:timeRange.days.tuesday"),
    t("translation:timeRange.days.wednesday"),
    t("translation:timeRange.days.thursday"),
    t("translation:timeRange.days.friday"),
    t("translation:timeRange.days.saturday"),
    t("translation:timeRange.days.sunday"),
  ];

  const {
    timeMonday,
    timeTuesday,
    timeWednesday,
    timeThursday,
    timeFriday,
    timeSaturday,
    timeSunday,
  } = props;

  const weekdayTimes = [
    timeMonday,
    timeTuesday,
    timeWednesday,
    timeThursday,
    timeFriday,
    timeSaturday,
    timeSunday,
  ];

  const formattedWeekdayTimes = weekdayTimes.map(formatWeekdayTime);

  return (
    <Box
      sx={{
        ...sharedStyles.horizontalContent,
        alignItems: { xs: "column", md: "row" },
        justifyContent: "space-between",
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      {formattedWeekdayTimes.map((day, index) => (
          <Box
            sx={{ ...sharedStyles.verticalContent, alignItems: "center" }}
              key={index}
          >
          <Typography variant="h6">{days[index]}</Typography>
          <Box sx={{ ...sharedStyles.verticalContent, gap: 0 }}>
            {day.length > 0 ? (
              day.map((time, index) => (<Typography key={index}>{time}</Typography>))
            ) : (
              <Typography>{t("translation:timeRange.unavailable")}</Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default TimeRangeInterpreter;
